if ( typeof MarketSuggestion !== 'function' ) {
	class MarketSuggestion extends HTMLElement {

		static get STORAGE_KEY() { return 'mc_market_choice'; }
		static get ENDPOINT() { return '/browsing_context_suggestions.json?country%5Benabled%5D=true'; }

		connectedCallback() {
			this.current = this.dataset.current;
			this.days = parseInt(this.dataset.days, 10) || 30;
			this.countryInput = this.querySelector('[data-js-suggestion-country]');
			this.textEl = this.querySelector('[data-js-suggestion-text]');
			this.switchTextEl = this.querySelector('[data-js-suggestion-switch-text]');

			this.querySelectorAll('[data-js-suggestion-stay]').forEach(btn=>{
				btn.addEventListener('click', ()=>{ this.remember('stay'); this.hide(); });
			});
			this.querySelector('[data-js-suggestion-switch]').addEventListener('click', ()=>{
				this.remember('switch');
			});

			if ( this.hasAttribute('data-design-mode') ) {
				// theme editor: show a sample so the merchant can style the bar
				this.show(this.current === 'LT' ? 'DE' : 'LT', this.current === 'LT' ? 'Germany' : 'Lithuania');
				return;
			}

			if ( this.rememberedChoice() ) return;

			this.detect().then(result=>{
				if ( ! result || ! result.code || result.code === this.current ) return;
				this.show(result.code, result.name);
			}).catch(()=>{});
		}

		rememberedChoice() {
			try {
				const saved = JSON.parse(localStorage.getItem(MarketSuggestion.STORAGE_KEY) || 'null');
				return saved && saved.until > Date.now();
			} catch ( e ) {
				return false;
			}
		}

		remember(choice) {
			try {
				localStorage.setItem(MarketSuggestion.STORAGE_KEY, JSON.stringify({
					choice: choice,
					country: this.suggested || null,
					until: Date.now() + this.days * 24 * 60 * 60 * 1000
				}));
			} catch ( e ) {}
		}

		detect() {
			const forced = new URLSearchParams(window.location.search).get('suggest_country');
			return fetch(MarketSuggestion.ENDPOINT, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
				.then(r=>r.json())
				.then(json=>{
					const detected = json && json.detected_values && json.detected_values.country ? json.detected_values.country.handle : null;
					const code = (forced || detected || '').toUpperCase();
					if ( ! code ) return null;
					// options = countries the shop actually ships to (from Markets); ignore anything else
					let options = null;
					try { options = json.suggestions[0].parts.country.options; } catch ( e ) {}
					const name = options && options[code] ? options[code] : null;
					if ( ! name ) return null;
					return { code: code, name: name };
				});
		}

		show(code, name) {
			this.suggested = code;
			this.countryInput.value = code;
			this.textEl.textContent = this.dataset.text.split('%COUNTRY%').join(name);
			this.switchTextEl.textContent = this.dataset.switch.split('%COUNTRY%').join(name);
			this.hidden = false;
			this.classList.add('market-suggestion--visible');
		}

		hide() {
			this.classList.remove('market-suggestion--visible');
			this.hidden = true;
		}

	}

	if ( typeof customElements.get('market-suggestion') == 'undefined' ) {
		customElements.define('market-suggestion', MarketSuggestion);
	}
}
